import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "../context/UserContext";
import dashboardIcon from "../assets/img/dashboard.svg";
import fileEarmarkIcon from "../assets/img/file-earmark-text.svg";
import diagramIcon from "../assets/img/diagram-2.svg";
import personIcon from "../assets/img/person.svg";
import godrejLogo from "../assets/img/godrej_logo.png";
import "../css/sidebar.css";

const Sidebar = ({ collapsed, setCollapsed }) => {
  const { role, sessionAccess } = useUser();
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
  const [masterDropdownOpen, setMasterDropdownOpen] = useState(false);

  const hasAccess = (sessionName) => {
    if (!sessionAccess) return role === "admin";
    return sessionAccess[sessionName] === true;
  };

  const regularMenuItems = [
    { name: "Generate Email Signature", sessionKey: "Generate email signature", path: "/app/CreateSignature", icon: fileEarmarkIcon },
  ];

  const masterMenuItems = [
    { name: "Address Master", sessionKey: "Address Master", path: "/app/AddressMaster" },
  ];

  const adminMenuItems = [
    { name: "Role & Authorization", sessionKey: "Role & Authorization", path: "/app/RoleMaster" },
    { name: "User Master", sessionKey: "User Master", path: "/app/UserMaster" },
    { name: "Audit Log", sessionKey: "Audit Log", path: "/app/AuditLog" },
  ];

  const filteredRegularItems = regularMenuItems.filter(item => hasAccess(item.sessionKey));
  const filteredMasterItems = masterMenuItems.filter(item => hasAccess(item.sessionKey));
  const filteredAdminItems = adminMenuItems.filter(item => hasAccess(item.sessionKey));
  const showMaster = filteredMasterItems.length > 0;
  const showAdmin = filteredAdminItems.length > 0;

  const toggleAdminDropdown = () => {
    setAdminDropdownOpen(!adminDropdownOpen);
  };

  const toggleMasterDropdown = () => {
    setMasterDropdownOpen(!masterDropdownOpen);
  };

  return (
    <div
      className={`sidebar ${collapsed ? "sidebar-collapse" : ""}`}
      id="sidebar"
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        height: "100vh",
        width: collapsed ? "60px" : "200px",
        backgroundColor: "#FFFFFF",
        borderRight: "1px solid #f1f1ed",
        transition: "width 0.3s ease",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0.7rem", borderBottom: "1px solid #e7e7e7", marginTop: "-7px", height: "43px", borderRadius: "0" }}>
        {!collapsed && <span style={{ color: "#707070", fontSize: "20px"}}>Menu</span>}
        <img
          src={dashboardIcon}
          className="icoNav"
          alt="dashboard"
          onClick={() => setCollapsed(prev => !prev)}
          style={{ cursor: "pointer", width: "30px", height: "30px", margin: 0, marginLeft: "auto" }}
        />
      </div>

      <ul className="links-tab" style={{ listStyle: "none", padding: "5px" }}>
        {showAdmin && (
          <li style={{ marginBottom: collapsed ? "15px" : "10px" }}>
            <div
              onClick={() => {
                if (collapsed) {
                  setCollapsed(false);
                } else {
                  toggleAdminDropdown();
                }
              }}
              style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "0px", 
                cursor: "pointer",
                padding: "0",
                color: "#707070",
                whiteSpace: "nowrap",
                justifyContent: collapsed ? "center" : "flex-start"
              }}
              title={collapsed ? "Admin" : ""}
            >
              <img src={personIcon} alt="Admin icon" style={{ width: "25px", height: "25px", filter: "brightness(0) saturate(100%) invert(44%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(96%) contrast(89%)" }} />
              {!collapsed && (
                <>
                  <span style={{ padding: "0", color: "#707070" }}>Admin</span>
                  <span style={{ marginLeft: "auto", fontSize: "12px" }}>
                    {adminDropdownOpen ? "▼" : "▶"}
                  </span>
                </>
              )}
            </div>
            
            {adminDropdownOpen && !collapsed && (
              <ul style={{ listStyle: "none", paddingLeft: "30px", margin: "5px 0" }}>
                {filteredAdminItems.map((item, index) => (
                  <li key={index} style={{ marginBottom: "5px" }}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => (isActive ? "active-link" : "")}
                      onClick={() => setCollapsed(true)}
                      style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: "0px",
                        padding: "0",
                        fontSize: "14px",
                        color: "#707070",
                        whiteSpace: "nowrap"
                      }}
                    >
                      <span style={{ padding: "0", color: "#707070" }}>{item.name}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )}

        {showMaster && (
          <li style={{ marginBottom: collapsed ? "15px" : "10px" }}>
            <div
              onClick={() => {
                if (collapsed) {
                  setCollapsed(false);
                } else {
                  toggleMasterDropdown();
                }
              }}
              style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "0px", 
                cursor: "pointer",
                padding: "0",
                color: "#707070",
                whiteSpace: "nowrap",
                justifyContent: collapsed ? "center" : "flex-start"
              }}
              title={collapsed ? "Master" : ""}
            >
              <img src={diagramIcon} alt="Master icon" style={{ width: "25px", height: "25px", filter: "brightness(0) saturate(100%) invert(44%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(96%) contrast(89%)" }} />
              {!collapsed && (
                <>
                  <span style={{ padding: "0", color: "#707070" }}>Master</span>
                  <span style={{ marginLeft: "auto", fontSize: "12px" }}>
                    {masterDropdownOpen ? "▼" : "▶"}
                  </span>
                </>
              )}
            </div>
            
            {masterDropdownOpen && !collapsed && (
              <ul style={{ listStyle: "none", paddingLeft: "30px", margin: "5px 0" }}>
                {filteredMasterItems.map((item, index) => (
                  <li key={index} style={{ marginBottom: "5px" }}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => (isActive ? "active-link" : "")}
                      onClick={() => setCollapsed(true)}
                      style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: "0px",
                        padding: "0",
                        fontSize: "14px",
                        color: "#707070",
                        whiteSpace: "nowrap"
                      }}
                    >
                      <span style={{ padding: "0", color: "#707070" }}>{item.name}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>
        )}

        {filteredRegularItems.map((item, index) => (
		//sonar fix start
          //<li key={index} style={{ marginBottom: collapsed ? "10px" : "10px" }}>
		  //sonar fix end
		  <li key={index} style={{ marginBottom: "10px" }}>
            <NavLink
              to={item.path}
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => {
                if (collapsed) {
                  setCollapsed(false);
                } else {
                  setCollapsed(true);
                }
              }}
              style={{ display: "flex", alignItems: "center", gap: "0px", whiteSpace: "nowrap", padding: "0", color: "#707070", justifyContent: collapsed ? "center" : "flex-start" }}
              title={collapsed ? item.name : ""}
            >
              <img src={item.icon} alt={`${item.name} icon`} style={{ width: "25px", height: "25px", filter: "brightness(0) saturate(100%) invert(44%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(96%) contrast(89%)" }} />
              {!collapsed && <span style={{ padding: "0", color: "#707070" }}>{item.name}</span>}
            </NavLink>
          </li>
        ))}
      </ul>

      <div style={{ position: "absolute", bottom: "20px", left: 0, right: 0, display: "flex", justifyContent: "center" }}>
        <img src={godrejLogo} alt="Godrej Logo" style={{ width: collapsed ? "30px" : "60px", height: collapsed ? "auto" : "28px", transition: "width 0.3s ease" }} />
      </div>
    </div>
  );
};

export default Sidebar;
